<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="公司公告" name="first">
        <div style="width: 100%">
          <div style="padding:6px 10px 10px;box-sizing: border-box">
            <img style="width: 100%;height: 150px" src="../../assets/wh.jpg" alt="瀚洋电信" title="瀚洋电信">
          </div>
          <a href="https://www.hanyangtelecom.com/about/show.php?id=39">
          <div class="colorStyle" style="font-size: 14px;text-indent: 2em!important;line-height: 25px;padding: 0 10px;box-sizing: border-box">
            上海瀚洋电信科技发展有限公司坚持可持续发展目标，紧密结合自身特点，把握转型方向，从2010年起，先后承接了上海电信10000号服务热线等多项外包业务。公司秉承“真诚感动用户，专业提升价值”的服务理念，坚持“诚信、责任、奉献、感恩”的企业精神，以精细化管理、提升服务为抓手，与各业务委托方紧密合作，建立了良好的合作管理模式，为各业务的运营指标完成奠定了坚实的基础。公司积极倡导技术革新，2012年取得高新技术企业资质后，从提升自身呼叫中心管理的角度出发，组织技术力量不断优化业务平台，先后自主开发了多项管理软件应用于实际管理中，并成功获得了34项软件著作权，有效促进了公司呼叫中心运营管理能力的提升。
          </div>
          </a>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'Homepage',
  data () {
    return {
      activeName: 'first'
    }
  },
  methods: {
    more (val) {
      this.$router.push({
        name: '/home/More',
        query: val
      })
    },
    detail (val) {
      this.$router.push({
        name: '/home/AnnouncementDetail',
        query: val
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .more{
    font-size: 15px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: right;
    margin: 0 0 8px 0;
  }
  .more>i:hover{
    color: #50aeee!important;
  }
  .title_style{
    font-size: 14px;width: 60%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;padding-right: 10px;box-sizing: border-box
  }
  .title_style:hover{
    color: #50aeee!important;
  }
  ::v-deep .el-tabs__nav-wrap {
    overflow: hidden;
    margin-bottom: -1px;
    position: relative;
    background-color: #409EFF;
    border-radius: 20px;
    padding: 0 10px;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #fff;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    content: none;
    background-color: #fff;
  }
  .colorStyle{
    color: #5f5a5a;
  }
  .colorStyle:hover{
    color: #928a8a !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/Announcement.vue